(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gst-breakdown"] && !Shopify.designMode) return;
  try {
    class GSTBreakdown extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      if (!this._initialized) {
        this.init();
        this._initialized = true;
      }
    }
    
    init() {
      if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
        console.warn('GST Breakdown: PubSub not available, retrying...');
        setTimeout(() => this.init(), 100);
        return;
      }
      
      this._unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        setTimeout(() => this.fetchAndUpdate(), 100);
      });
    }
    
    disconnectedCallback() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._initialized = false;
    }
    
    async fetchAndUpdate() {
      try {
        const cartUrl = (window.Shopify?.routes?.root || window.routes?.root || '/') + 'cart.js';
        const response = await fetch(cartUrl);
        const cart = await response.json();
        this.updateBreakdown(cart);
      } catch (error) {
        console.error('Failed to fetch cart:', error);
      }
    }
    
    updateBreakdown(cart) {
      const ratesMapElement = document.getElementById('GST-Rates-Map');
      const ratesMap = ratesMapElement ? JSON.parse(ratesMapElement.textContent) : {};
      
      const tbody = this.querySelector('.gst-breakdown__items');
      if (!tbody) return;
      
      // Clear existing rows
      tbody.innerHTML = '';
      
      let totalTaxable = 0;
      let totalGst = 0;
      let firstRate = null;
      let isMixedRate = false;
      
      // Build rows for each item
      cart.items.forEach(item => {
        const rate = ratesMap[item.product_id] || 18;
        
        if (firstRate === null) {
          firstRate = rate;
        } else if (firstRate !== rate) {
          isMixedRate = true;
        }
        
        const divisor = 1 + (rate / 100);
        const itemTotal = (item.final_line_price || item.line_price) / 100;
        const itemTaxable = this.roundTo2(itemTotal / divisor);
        const itemGst = this.roundTo2(itemTotal - itemTaxable);
        
        totalTaxable += itemTaxable;
        totalGst += itemGst;
        
        const row = document.createElement('tr');
        row.className = 'gst-breakdown__item-row';
        row.dataset.lineItemKey = item.key;
        row.dataset.productId = item.product_id;
        
        const qtyText = item.quantity > 1 ? `<span class="gst-breakdown__qty">(&times;${item.quantity})</span>` : '';
        const variantText = item.variant_title && item.variant_title !== 'Default Title' 
          ? `<div class="gst-breakdown__variant">${item.variant_title}</div>` 
          : '';
        
        row.innerHTML = `
          <td class="gst-breakdown__col-item">
            <div class="gst-breakdown__item-name">${item.product_title}${qtyText}</div>
            ${variantText}
          </td>
          <td class="gst-breakdown__col-taxable">${this.formatMoney(itemTaxable)}</td>
          <td class="gst-breakdown__col-gst">
            <span class="gst-breakdown__gst-amount">${this.formatMoney(itemGst)}</span>
            <span class="gst-breakdown__gst-rate">@ ${rate}%</span>
          </td>
          <td class="gst-breakdown__col-total">${this.formatMoney(itemTotal)}</td>
        `;
        
        tbody.appendChild(row);
      });
      
      // Update subtotal row
      const productTotal = cart.items_subtotal_price / 100;
      const subtotalTaxable = this.querySelector('.gst-breakdown__subtotal-taxable');
      const subtotalGst = this.querySelector('.gst-breakdown__subtotal-gst');
      const subtotalTotal = this.querySelector('.gst-breakdown__subtotal-total');
      
      if (subtotalTaxable) subtotalTaxable.textContent = this.formatMoney(this.roundTo2(totalTaxable));
      if (subtotalGst) subtotalGst.textContent = this.formatMoney(this.roundTo2(totalGst));
      if (subtotalTotal) subtotalTotal.textContent = this.formatMoney(productTotal);
      
      // Update notice text
      const gstNotice = this.querySelector('.gst-breakdown__notice');
      if (gstNotice) {
        if (isMixedRate) {
          gstNotice.textContent = window.gstBreakdownStrings?.allPricesIncludeGstMixed || 'All prices include GST at varying rates';
        } else if (firstRate !== null) {
          const noticeTemplate = window.gstBreakdownStrings?.allPricesIncludeGstAtRate || 'All prices include GST @ {rate}%';
          gstNotice.textContent = noticeTemplate.replace('{rate}', firstRate);
        } else {
          gstNotice.textContent = window.gstBreakdownStrings?.allPricesIncludeGst || 'All prices include applicable GST';
        }
      }
      
      // Update data attributes
      this.dataset.productTotal = productTotal;
      this.dataset.isMixedRate = isMixedRate;
      this.dataset.uniformRate = firstRate || 18;
    }
    
    roundTo2(num) {
      return Math.round(num * 100) / 100;
    }
    
    formatMoney(amount) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount);
    }
  }
  
  customElements.define('gst-breakdown', GSTBreakdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pincode-checker"] && !Shopify.designMode) return;
  try {
    class PincodeChecker extends HTMLElement {
    constructor() {
      super();
      this.context = this.dataset.context || 'cart-page';
      this.input = this.querySelector('.pincode-checker__input');
      this.button = this.querySelector('.pincode-checker__button');
      this.resultContainer = this.querySelector('.pincode-checker__result');
      this.resultContent = this.querySelector('.pincode-checker__result-content');
      this.savedContainer = this.querySelector('.pincode-checker__saved');
      this.savedValue = this.querySelector('.pincode-checker__saved-value');
      this.changeBtn = this.querySelector('.pincode-checker__change-btn');
      
      this.pincodeData = null;
      this.localStorageKey = 'seiki_delivery_pincode';
      
      this.init();
    }
    
    async init() {
      await this.loadPincodeData();
      this.attachEventListeners();
      this.checkSavedPincode();
    }
    
    async loadPincodeData() {
      try {
        const response = await fetch(window.Shopify?.routes?.root + 'assets/mumbai-pincodes.json');
        this.pincodeData = await response.json();
      } catch (error) {
        console.error('Failed to load pincode data:', error);
        // Fallback to hardcoded ranges
        this.pincodeData = {
          sameDayEligible: {
            mumbai: { name: 'Mumbai City', range: [400001, 400104] },
            naviMumbai: { name: 'Navi Mumbai', range: [400614, 400709] },
            thane: { name: 'Thane', range: [400601, 400612] }
          },
          sameDayPeriod: {
            start: '2026-02-08T00:00:00',
            end: '2026-02-14T23:59:59'
          },
          sameDayPrice: 1500,
          standardDeliveryDays: '5-7'
        };
      }
    }
    
    attachEventListeners() {
      // Check button click
      this.button.addEventListener('click', () => this.checkPincode());
      
      // Enter key in input
      this.input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.checkPincode();
        }
      });
      
      // Only allow numeric input
      this.input.addEventListener('input', (e) => {
        e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6);
      });
      
      // Change button click
      this.changeBtn?.addEventListener('click', () => this.enableEditing());
      
      // Listen for pincode updates from other components
      document.addEventListener('pincode-updated', (e) => {
        if (e.detail.source !== this.context) {
          this.syncPincode(e.detail.pincode, e.detail.result);
        }
      });
    }
    
    checkSavedPincode() {
      const saved = localStorage.getItem(this.localStorageKey);
      if (saved) {
        try {
          const data = JSON.parse(saved);
          if (data.pincode && data.timestamp) {
            // Check if saved data is less than 7 days old
            const sevenDays = 7 * 24 * 60 * 60 * 1000;
            if (Date.now() - data.timestamp < sevenDays) {
              this.input.value = data.pincode;
              this.checkPincode(true); // Silent check
              return;
            }
          }
        } catch (e) {
          localStorage.removeItem(this.localStorageKey);
        }
      }
    }
    
    checkPincode(silent = false) {
      const pincode = this.input.value.trim();
      
      // Validate format
      if (!/^\d{6}$/.test(pincode)) {
        this.showResult('error', {
          title: window.pincodeCheckerStrings?.invalidPincode || 'Please enter a valid 6-digit pincode',
          subtitle: ''
        });
        return;
      }
      
      const pincodeNum = parseInt(pincode, 10);
      const isEligible = this.isSameDayEligible(pincodeNum);
      const isInPeriod = this.isWithinSameDayPeriod();
      
      let result;
      
      if (isEligible && isInPeriod) {
        result = {
          status: 'same-day',
          title: window.pincodeCheckerStrings?.sameDayAvailable || 'Same Day Delivery available!',
          subtitle: window.pincodeCheckerStrings?.sameDaySubtitle || 'Select at checkout (\u20B91,500)',
          region: this.getRegionName(pincodeNum)
        };
      } else if (isEligible && !isInPeriod) {
        result = {
          status: 'standard',
          title: window.pincodeCheckerStrings?.standardOnly || 'Free Standard Delivery',
          subtitle: window.pincodeCheckerStrings?.standardSubtitle || 'Arrives in 5-7 business days',
          note: window.pincodeCheckerStrings?.sameDayPeriod || 'Same-day delivery available Feb 8-14 only'
        };
      } else {
        result = {
          status: 'standard',
          title: window.pincodeCheckerStrings?.standardOnly || 'Free Standard Delivery',
          subtitle: window.pincodeCheckerStrings?.standardSubtitle || 'Arrives in 5-7 business days'
        };
      }
      
      this.showResult(result.status, result);
      this.savePincode(pincode, result);
      
      // Notify other components
      document.dispatchEvent(new CustomEvent('pincode-updated', {
        detail: { pincode, result, source: this.context }
      }));
      
      // Show saved state after a short delay
      if (!silent) {
        setTimeout(() => {
          this.showSavedState(pincode, result);
        }, 2000);
      } else {
        this.showSavedState(pincode, result);
      }
    }
    
    isSameDayEligible(pincode) {
      if (!this.pincodeData?.sameDayEligible) return false;
      
      for (const region of Object.values(this.pincodeData.sameDayEligible)) {
        const [min, max] = region.range;
        if (pincode >= min && pincode <= max) {
          return true;
        }
      }
      return false;
    }
    
    getRegionName(pincode) {
      if (!this.pincodeData?.sameDayEligible) return '';
      
      for (const region of Object.values(this.pincodeData.sameDayEligible)) {
        const [min, max] = region.range;
        if (pincode >= min && pincode <= max) {
          return region.name;
        }
      }
      return '';
    }
    
    isWithinSameDayPeriod() {
      if (!this.pincodeData?.sameDayPeriod) return false;
      
      const now = new Date();
      const start = new Date(this.pincodeData.sameDayPeriod.start);
      const end = new Date(this.pincodeData.sameDayPeriod.end);
      
      return now >= start && now <= end;
    }
    
    showResult(status, data) {
      this.resultContainer.hidden = false;
      this.resultContainer.dataset.status = status;
      
      let iconSvg = '';
      if (status === 'same-day') {
        iconSvg = '<svg class="pincode-checker__result-icon" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>';
      } else if (status === 'standard') {
        iconSvg = '<svg class="pincode-checker__result-icon" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>';
      } else {
        iconSvg = '<svg class="pincode-checker__result-icon" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';
      }
      
      let html = `
        ${iconSvg}
        <div class="pincode-checker__result-text">
          <div class="pincode-checker__result-title">${data.title}</div>
          ${data.subtitle ? `<div class="pincode-checker__result-subtitle">${data.subtitle}</div>` : ''}
          ${data.note ? `<div class="pincode-checker__result-subtitle" style="margin-top: 0.25rem; font-style: italic;">${data.note}</div>` : ''}
        </div>
      `;
      
      this.resultContent.innerHTML = html;
    }
    
    showSavedState(pincode, result) {
      this.savedValue.textContent = pincode;
      this.classList.add('pincode-checker--has-saved');
      
      // Update result display for saved state
      if (result.status === 'same-day') {
        this.savedValue.style.color = '#22c55e';
      } else {
        this.savedValue.style.color = '';
      }
    }
    
    enableEditing() {
      this.classList.remove('pincode-checker--has-saved');
      this.classList.add('pincode-checker--editing');
      this.input.focus();
      this.input.select();
    }
    
    savePincode(pincode, result) {
      const data = {
        pincode,
        result,
        timestamp: Date.now()
      };
      localStorage.setItem(this.localStorageKey, JSON.stringify(data));
    }
    
    syncPincode(pincode, result) {
      this.input.value = pincode;
      this.showResult(result.status, result);
      this.showSavedState(pincode, result);
    }
  }
  
  customElements.define('pincode-checker', PincodeChecker);
  } catch(e) { console.error(e); }
})();

})();
